import React from 'react';

interface addBtnProps{
    name: string,
    onClickFn: ()=>any
}

export default function AddBtn({name, onClickFn}: addBtnProps) {
  return (
    <div className='addItem'><div className='addItemBtn' onClick={onClickFn}>{name}</div></div>
  )
}
